'use client';

import { __spreadArray } from '../../_virtual/_tslib.js';
import React__default from 'react';
import { GlobalStateContext } from '../context.js';

function FormProvider(_a) {
    var initialState = _a.initialState, children = _a.children;
    var subscribers = new Map();
    function subscribeField(field, callback) {
        var fieldSubscribers = subscribers.get(field) || [];
        subscribers.set(field, __spreadArray(__spreadArray([], fieldSubscribers, true), [callback], false));
        return function () {
            var updatedSubscribers = fieldSubscribers.filter(function (subscriber) {
                return subscriber !== callback;
            });
            subscribers.set(field, updatedSubscribers);
        };
    }
    var notifySubscribers = function (field, value) {
        var fieldSubscribers = subscribers.get(field) || [];
        fieldSubscribers.forEach(function (subscriber) {
            subscriber({ field: field, value: value });
        });
    };
    var createNestedProxy = function (state, path) {
        if (path === void 0) { path = []; }
        var proxyHandler = {
            get: function (target, prop) {
                var newPath = __spreadArray(__spreadArray([], path, true), [prop.toString()], false); // Create new path
                if (typeof window !== 'undefined' && target[prop] instanceof File) {
                    return target[prop];
                }
                if (target[prop] instanceof Date) {
                    return target[prop];
                }
                if (target[prop] instanceof Array) {
                    return target[prop].map(function (value) {
                        if (typeof window !== 'undefined' && target[prop] instanceof File) {
                            return value;
                        }
                        if (value instanceof Date) {
                            return value;
                        }
                        if (value instanceof Object) {
                            return createNestedProxy(value, newPath);
                        }
                        return value;
                    });
                }
                if (target[prop] instanceof Object && target[prop] !== null) {
                    return createNestedProxy(target[prop], newPath);
                }
                return target[prop];
            },
            set: function (target, prop, value) {
                var fullPath = __spreadArray(__spreadArray([], path, true), [prop.toString()], false);
                target[prop] = value;
                notifySubscribers(fullPath.join('.'), value);
                return true;
            },
            deleteProperty: function (target, prop) {
                var fullPath = __spreadArray(__spreadArray([], path, true), [prop.toString()], false);
                if (prop in target) {
                    delete target[prop];
                }
                notifySubscribers(fullPath.join('.'), undefined);
                return true;
            }
        };
        return new Proxy(state, proxyHandler);
    };
    var globalState = createNestedProxy(initialState);
    var globalStateContextValue = {
        globalState: globalState,
        subscribeField: subscribeField
    };
    return React__default.createElement(GlobalStateContext.Provider, { value: globalStateContextValue }, children);
}

export { FormProvider as default };
//# sourceMappingURL=FormProvider.js.map
